export var BillingCycles;
(function (BillingCycles) {
    BillingCycles["Monthly"] = "Monthly";
    BillingCycles["Annual"] = "Annual";
    BillingCycles["SemiAnnual"] = "Semi-Annual";
    BillingCycles["Quarterly"] = "Quarterly";
})(BillingCycles || (BillingCycles = {}));
